import { takeLatest, call, put,} from '@redux-saga/core/effects'
import axios from 'axios';
import { createDatabaseApi } from 'consents/apis';
import { createUserApi } from 'consents/apis';
import { createDatabaseData } from 'Actions/createDatabaseAction';
import { X_API_KEY } from 'config';
import { USER_X_API_KEY } from 'config';

export function* watchCreateDatabase(){
    yield takeLatest('CREATE_DATABASE_ACTION',handleCreateDatabase);
}

function* handleCreateDatabase({payload}){
    try {
        const message = yield call(createNewDatabase,payload);
        yield put(createDatabaseData(message));
    } catch (error) {
        console.error('Create database saga failed:', error);
        yield put({ type: 'CREATE_DATABASE_FAILED', payload: error.message || 'Database creation failed' });
    }
}

const createNewDatabase = async (customerDetails) =>{
    const token = localStorage.getItem('token');
    const res = await axios.post(createDatabaseApi,customerDetails,{
        headers:{
            "x-api-key":X_API_KEY,
            ...(token && { "Authorization": token })
        }
    });
    const userDetails = {
        customerId:customerDetails.customerId,
        tenantId:res.data.tenantId
    }
    const user = await axios.post(createUserApi,userDetails,
        {
            headers:{
                "x-api-key":USER_X_API_KEY,
                ...(token && { "Authorization": token })
            }
        })
    return user.data.message
}